import { StoreListenerUtils } from './store-listener-utils.service';

export const StoreListenerUtilsModule = angular
  .module('storeListenerUtils', [])
  .service('StoreListenerUtils', StoreListenerUtils).name;
